import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { TextField } from "@mui/material";
import moment from "moment";
import { getLocalStorage } from "../layout/cookies/CookieFunctions";

const DatePickerComponent = (props) => {
  const {
    name,
    label,
    value,
    setFieldValue,
    variant,
    margin,
    required,
    disableFuture,
    zIndex,
    disabled,
  } = props;

  var parentParams = {};
  if (required) {
    parentParams.required = required;
  }

  const locale = getLocalStorage("locale") || "en-us";

  if (moment.locale() !== locale) {
    moment.locale(locale);
  }

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
      <DatePicker
        fullWidth
        inputVariant={variant || "outlined"}
        label={label}
        name={name}
        autoOk
        clearable
        disabled={disabled}
        disableFuture={disableFuture || false}
        value={moment(value)}
        onChange={(newMoment) => {
          if (newMoment && newMoment !== null) {
            setFieldValue(name, new Date(newMoment.startOf("day").format()));
          } else {
            setFieldValue(name, null);
          }
        }}
        {...parentParams}
        renderInput={(params) => (
          <TextField
            {...params}
            disabled={disabled}
            fullWidth
            margin={margin}
          />
        )}
        PopperProps={{
          sx: {
            zIndex: `${(zIndex || 99990) + 3} !important`,
          },
        }}
        sx={{ width: "100%" }}
      />
    </LocalizationProvider>
  );
};

export default DatePickerComponent;
